import { useMutation, useQueryClient } from '@tanstack/react-query';

import { FILTER_VIEWS_KEY } from './constants';
import { deleteFilterView } from './filterViews';

/**
 * Hook to delete a filter view
 */
export const useDeleteFilterView = (pageIdentifier: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => deleteFilterView(pageIdentifier, id),
    onSuccess: () => {
      // Invalidate the filter views query to refetch
      queryClient.invalidateQueries({
        queryKey: [FILTER_VIEWS_KEY, pageIdentifier],
      });
    },
  });
};
